module.exports = __webpack_public_path__ + "fonts/iconfont.895b8223.ttf";